<template>
  <main class="content container">
    <div class="content__top content__top--catalog">
      <h1 class="content__title">
        Каталог
      </h1>
      <span class="content__info">
        152 товара
      </span>
    </div>

    <div class="content__catalog">
      <ProductFilter :price-from.sync="filterPriceFrom" :price-to.sync="filterPriceTo"
       :category-id.sync="filterCategoryId" :color-id.sync="filterColorId">
      </ProductFilter>

      <section class="catalog">
        <div v-if="productsLoading" style="color: blue; font: 4em sans-serif; margin: auto;">
          <img src="../../public/img/Spinning line.gif" alt="Загрузка товаров...">
          <div>
            Загрузка товаров...
          </div>
        </div>
        <div  v-if="productsLoadingFailed" style="color: blue; font: 3em sans-serif; margin: auto;
          text-align: center;">
          <div>
            Произошла ошибка при загрузке товаров
          </div>
          <button @click.prevent="loadProducts" style="background-color: yellowgreen;
            color: tomato; padding: 15px; font: .5em sans-serif; border-radius: 10px;">
            Попробовать еще раз
          </button>
        </div>
        <ProductList :products="products"></ProductList>
        <BasePagination v-model="page" :count="countProducts" :per-page="productsPerPage">
        </BasePagination>
      </section>
    </div>
  </main>
</template>

<script>
// import products from '@/data/products';
import ProductList from '@/components/ProductList.vue';
import BasePagination from '@/components/BasePagination.vue';
import ProductFilter from '@/components/ProductFilter.vue';
import axios from 'axios';
import API_BASE_URL from '../config';

export default {
  components: { ProductList, BasePagination, ProductFilter },
  data() {
    return {
      filterPriceFrom: 0,
      filterPriceTo: 0,
      filterCategoryId: 0,
      filterColorId: 0,
      page: 1,
      productsPerPage: 3,
      productsData: null,
      productsLoading: false,
      productsLoadingFailed: false,
    };
  },
  computed: {
    // filteredProducts() {
    //   let filteredProducts = products;

    //   if (this.filterPriceFrom > 0) {
    //     filteredProducts = filteredProducts.filter((product) => product.price
    //      > this.filterPriceFrom);
    //   }
    //   if (this.filterPriceTo > 0) {
    //     filteredProducts = filteredProducts.filter((product) => product.price
    //      < this.filterPriceTo);
    //   }
    //   if (this.filterCategoryId) {
    //     filteredProducts = filteredProducts.filter((product) => product.categoryId
    //      === this.filterCategoryId);
    //   }
    //   if (this.filterColorId) {
    //     filteredProducts = filteredProducts.filter((product) => product
    //       .colorId.includes(this.filterColorId));
    //   }
    //   return filteredProducts;
    // },
    products() {
      // const offset = (this.page - 1) * this.productsPerPage;
      // return this.filteredProducts.slice(offset, offset + this.productsPerPage);
      return this.productsData
        // eslint-disable-next-line arrow-body-style
        ? this.productsData.items.map((product) => {
          return {
            ...product,
            image: product.image.file.url,
          };
        })
        : [];
    },
    countProducts() {
      // return this.filteredProducts.length;
      return this.productsData ? this.productsData.pagination.total : 0;
    },
  },
  methods: {
    loadProducts() {
      this.productsLoading = true;
      this.productsLoadingFailed = false;
      clearTimeout(this.loadProductsTimer);
      this.loadProductsTimer = setTimeout(() => {
        axios.get(`${API_BASE_URL}/api/products`, {
          params: {
            page: this.page,
            limit: this.productsPerPage,
            colorId: this.filterColorId,
            categoryId: this.filterCategoryId,
            minPrice: this.filterPriceFrom,
            maxPrice: this.filterPriceTo,
          },
        })
          // eslint-disable-next-line no-return-assign
          .then((response) => this.productsData = response.data)
          .catch(() => { this.productsLoadingFailed = true; })
          .then(() => { this.productsLoading = false; });
      }, 0);
    },
  },
  watch: {
    page() {
      this.loadProducts();
    },
    filterPriceFrom() {
      this.loadProducts();
    },
    filterPriceTo() {
      this.loadProducts();
    },
    filterCategoryId() {
      this.loadProducts();
    },
    filterColorId() {
      this.loadProducts();
    },
  },
  created() {
    this.loadProducts();
  },
};
</script>
